const style = {
  dialogTitle: {
    mt: '15px',
  },
  dialogAction: {
    pr: '25px',
  },
  titleBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  titleVariant: 'h5',
  closeIcon: {
    color: 'action.active',
  },
} as const;

export default style;
